import axios from "axios";
import moment from "moment";
import { toast } from "react-toastify";
import socketIO from "../../Socket/socketIO";

import {
  FETCH_DISPATCH,
  CREATE_DISPATCH,
  DELETE_DISPATCH,
  UPDATE_DISPATCH,
  COPY_ITEM,
  UPDATE_TEAM_JOB,
  COPY_DISPATCHES,
  REORDER_DISPATCHES,
  REORDER_JOBS,
  CHANGE_DATE,
  ADD_COPY_TEAMS,
  COPY_ALL_TEAMS,
  DELETE_JOBS,
  UPDATE_TEAMS_VISIBILITY,
} from "./constants";

function mergeUnique(arr) {
  return [...new Set([].concat(...arr))];
}

export const fetchDispatch = (date) => (dispatch, getState) => {
  let formattedDate = date;
  let d = moment.utc();

  if (date) {
    d = moment.utc(date);
  }

  formattedDate = d.format("YYYY-MM-DD");

  return Promise.all([
    axios.get("/api/v1/employees").then((res) => res.data.employees),
    axios.get("/api/v1/trucks").then((res) => res.data.trucks),
    axios.get("/api/v1/toolboxes").then((res) => res.data.toolboxes),
    axios.get("/api/v1/clients").then((res) => res.data.clients),
    axios
      .get(`/api/v1/teams/jobs/${formattedDate}`)
      .then((res) => res.data.jobs),
    axios
      .get(`api/v1/dispatch/by_date/${formattedDate}`, {
        data: { type: "forms" },
      })
      .then((res) => res.data),
  ])
    .then(([employees, trucks, toolboxes, jobs, teamJobs, byDate]) => {
      const isAdmin = getState().auth.user.userType === "admin";
      dispatch({
        type: FETCH_DISPATCH,
        payload: {
          teams: byDate.teams,
          teamJobs,
          employees,
          trucks,
          toolboxes,
          jobs: isAdmin ? jobs : {},
        },
      });
    })
    .then(() => {
      localStorage.setItem("casa-date", formattedDate);
      changeDate(formattedDate)(dispatch);
    })
    .catch(() => {
      toast.error(`Impossible d'obtenir la cédule du ${formattedDate}`);
    });
};

export const createDispatch = () => (dispatch, getState) => {
  const { teams } = getState().dispatch;
  const teamsLength = Object.keys(teams).length;
  const { date } = getState().dispatch;
  const object = { index: teamsLength, date };
  return socketIO().emit("create-team", object);
};

// TODO: USE THIS ACTION WHEN RECEIVING CREATE ACTION FROM SOCKETS
export const dispatchCreateDispatch = (team, teamJobs) => (
  dispatch,
  getState
) => {
  const { date } = getState().dispatch;
  if (date !== team[0].date) {
    return;
  }
  dispatch({
    type: CREATE_DISPATCH,
    payload: {
      team,
      teamJobs,
    },
  });
};

export const deleteDispatch = (id, date, index) => () =>
  socketIO().emit("delete-team", { id, date, index });

// TODO: USE THIS ACTION WHEN RECEIVING DELETE ACTION FROM SOCKETS
export const dispatchDeleteDispatch = (id) => (dispatch, getState) => {
  const team = !!getState().dispatch.teams[id];
  if (!team) {
    return;
  }
  return dispatch({
    type: DELETE_DISPATCH,
    payload: {
      id,
    },
  });
};

export const updateDispatch = (team) => () =>
  socketIO().emit("update-team", team);

// TODO: USE THIS ACTION WHEN RECEIVING UPDATE ACTION FROM SOCKETS
export const dispatchUpdateDispatch = (team, teamJobs) => (
  dispatch,
  getState
) => {
  const { date } = getState().dispatch;
  if (date !== team.date) {
    return;
  }
  dispatch({
    type: UPDATE_DISPATCH,
    payload: {
      team,
      teamJobs,
    },
  });
};

// Update/Remove any value in a dispatch team from [trucks, employees, toolboxes, jobs]
export const updateListItemFromDispatch = (teamID, listKey, itemID, value) => (
  dispatch,
  getState
) => {
  let team = { ...getState().dispatch.teams[teamID] };
  let list = [...team[listKey]];
  let removedIndex;

  // Update value with new
  if (value) {
    list = list.map((listItem) => {
      if (listItem === itemID) {
        return value;
      }
      return listItem;
    });
  } else {
    // If value is null remove it
    list = list.filter((listItem, index) => {
      if (listItem === itemID) {
        removedIndex = index;
      }
      return listItem !== itemID;
    });
  }

  // we need to remove tmp jobs also if key is jobs
  if (team.tmp_jobs_ids) {
    let tmp_jobs_ids = [...team.tmp_jobs_ids];
    if (listKey === "jobs") {
      tmp_jobs_ids = tmp_jobs_ids.filter((id, index) => index !== removedIndex);
    }

    team = { ...team, [listKey]: list, tmp_jobs_ids };
  } else {
    team = { ...team, [listKey]: list };
  }

  updateDispatch(team)(dispatch);
};

// Update any value in a dispatch team from [note, hour, title, date]
export const updateItemFromDispatch = (teamID, key, value) => (
  dispatch,
  getState
) => {
  let team = { ...getState().dispatch.teams[teamID] };
  team = { ...team, [key]: value };
  updateDispatch(team)(dispatch);
};

export const copyItem = (copyType, copyPayload, e) => (dispatch) => {
  dispatch({
    type: COPY_ITEM,
    payload: {
      copyType,
      copyPayload,
      fromTeamID: e,
    },
  });
};

export const pasteItem = (teamID) => (dispatch, getState) => {
  const prevState = getState().dispatch;
  const team = { ...prevState.teams[teamID] };
  const key = prevState.copyType;
  const value = prevState.copyPayload;
  let newTeam;

  // is array -> append the data
  if (value) {
    if (value.constructor === Array) {
      // make sure ids are unique
      const initialValue = team[key];
      const mergedValues = mergeUnique([initialValue, value]);
      newTeam = { ...team, [key]: mergedValues };
    } else if (value.trucks) {
      const initialTrucks = team.trucks;
      const mergedTrucks = mergeUnique([initialTrucks, value.trucks]);

      const initialToolboxes = team.toolboxes;
      const mergedToolboxes = mergeUnique([initialToolboxes, value.toolboxes]);

      newTeam = { ...team, trucks: mergedTrucks, toolboxes: mergedToolboxes };
    } else {
      // or overwrite
      newTeam = { ...team, [key]: value };
    }
  }

  updateDispatch(newTeam)(dispatch);
  dispatch({
    type: COPY_ITEM,
    payload: {
      copyType: "",
      copyPayload: null,
    },
  });
};

// PUT    /jobs/:id(.:format)                 jobs#update
export const updateTeamJob = (job) => (dispatch) =>
  axios
    .put(`/api/v1/jobs/${job.id}`, { object: job })
    .then(() => {
      dispatch({
        type: UPDATE_TEAM_JOB,
        payload: {
          job,
        },
      });
    })
    .catch(() => {
      toast.error("Impossible de mettre à jour le travail");
    });

export const reorderDispatches = (teamID, startIndex, endIndex) => (
  dispatch,
  getState
) => {
  const object = {
    teamID,
    startIndex,
    endIndex,
    date: getState().dispatch.date,
  };
  dispatch({
    type: REORDER_DISPATCHES,
    payload: object,
  });
  return socketIO().emit("reorder-team", object);
};

export const dispatchReorderDispatches = (teamID, startIndex, endIndex) => (
  dispatch,
  getState
) => {
  const team = !!getState().dispatch.teams[teamID];
  if (!team) {
    return;
  }

  const payload = {
    teamID,
    startIndex,
    endIndex,
    date: getState().dispatch.date,
  };

  dispatch({
    type: REORDER_DISPATCHES,
    payload,
  });
};

export const reorderJobs = (teamID, startIndex, endIndex) => (
  dispatch,
  getState
) => {
  if (startIndex !== endIndex) {
    let finalIndex = endIndex;
    const { jobs } = getState().dispatch.teams[teamID];
    const allJobs = getState().dispatch.teamJobs;
    const jobsLength = jobs.length - 1;
    if (endIndex > jobsLength) {
      finalIndex = jobsLength;
    }
    const jobID = jobs.find((j) => {
      return allJobs[j].index === startIndex;
    });
    if (jobID) {
      dispatch({
        type: REORDER_JOBS,
        payload: {
          jobID,
          teamID,
          startIndex,
          endIndex: finalIndex,
        },
      });
      return socketIO().emit("reorder-teamJob", {
        jobID,
        teamID,
        startIndex,
        endIndex: finalIndex,
        date: getState().dispatch.date,
      });
    }
  }
};

export const dispatchReorderJobs = (teamID, jobID, startIndex, endIndex) => (
  dispatch
) => {
  // Dispatch action
  dispatch({
    type: REORDER_JOBS,
    payload: {
      startIndex,
      endIndex,
      teamID,
      jobID,
    },
  });
};

export const copyDispatches = (arrayOfJobs) => (dispatch) => {
  dispatch({
    type: COPY_DISPATCHES,
    payload: {
      arrayOfJobs,
    },
  });
};

export const changeDate = (date) => (dispatch) => {
  dispatch({
    type: CHANGE_DATE,
    payload: {
      date,
    },
  });
};

export const copyAllTeams = () => (dispatch) => {
  dispatch({
    type: COPY_ALL_TEAMS,
  });
};

export const pasteTeams = () => (dispatch, getState) => {
  const { date } = getState().dispatch;
  const dispatchTeams = getState().dispatch.teams;
  const firstIndex = dispatchTeams ? Object.values(dispatchTeams).length : 0;
  const teams = Object.values(getState().dispatch.copyPayload);
  teams.sort((a, b) => a.index - b.index);

  return socketIO().emit("paste-team", { date, teams, firstIndex });
};

export const addCopyTeams = (team) => (dispatch) => {
  dispatch({
    type: ADD_COPY_TEAMS,
    payload: {
      team,
    },
  });
};

export const deleteJobs = (teamID, jobsToRemove, index) => (
  dispatch,
  getState
) =>
  socketIO().emit("delete-teamJob", {
    teamID,
    jobsToRemove,
    index,
    date: getState().dispatch.date,
  });

export const teamJobsDeleted = (teamID, jobsToRemove) => (dispatch) =>
  dispatch({
    type: DELETE_JOBS,
    payload: {
      teamID,
      jobsToRemove,
    },
  });

export const addJobs = (teamID, jobsToAdd, fromTeamID) => (
  dispatch,
  getState
) => {
  const team = { ...getState().dispatch.teams[teamID] };
  const object = {
    jobsToAdd,
    fromTeamID,
    date: getState().dispatch.date,
    ...team,
  };

  dispatch({
    type: COPY_ITEM,
    payload: {
      copyType: "",
      copyPayload: null,
    },
  });
  return socketIO().emit("update-team", object);
};

export const updateVisibility = (date, visible, emit = false) => (dispatch) => {
  dispatch({
    type: UPDATE_TEAMS_VISIBILITY,
    payload: {
      date,
      visible,
    },
  });
  if (emit) {
    socketIO().emit("update-teams-visibility", {
      date,
      visible,
    });
  }
};
